"use client";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router-dom";

import FormField from "@/components/atoms/FormField";
import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { SubjectFormMessages } from "@/messages/subject/subject-form.messages";

import { subjectFormNames } from "./form-data";
import { SubjectFormData } from "./types";

type Props = {
  messages: SubjectFormMessages;
  isLoading: boolean;
  isViewing?: boolean;
};

function SubjectForm({ messages, isLoading, isViewing = false }: Props) {
  const router = useNavigate();
  const { lang } = useLanguage();
  const formik = useFormikContext<SubjectFormData>();
  const { values, errors, submitForm, handleChange } = formik;
  const isReadOnly = isViewing;

  return (
    <MDBox>
      <Card>
        <MDBox p={3}>
          <MDTypography variant="h5">{messages.subjectCardTitle}</MDTypography>
        </MDBox>

        <MDBox component="form" pb={3} px={3}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormField
                placeholder={messages.subjectPlaceholder}
                fullWidth
                variant="standard"
                label={messages.subjectLabel}
                name={subjectFormNames.subject}
                onChange={handleChange}
                value={values.subject}
                error={!!errors.subject}
                helperText={errors.subject}
                required
                disabled={isReadOnly}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Card>

      <MDBox mt={2} display="flex" justifyContent="flex-end" gap={2}>
        <MDButton
          variant="gradient"
          color="light"
          onClick={() => router(ROUTE_URLS.subjects(lang))}
          isLoading={isLoading}
        >
          {isReadOnly ? messages.backButton : messages.cancelButton}
        </MDButton>

        {!isReadOnly && (
          <MDButton variant="gradient" color="dark" onClick={submitForm} isLoading={isLoading}>
            {messages.updateButton}
          </MDButton>
        )}
      </MDBox>
    </MDBox>
  );
}

export default SubjectForm;
